import { Box, Card, CardContent, CircularProgress, Divider, Grid, Typography } from "@mui/material";
import { useContext, useEffect } from "react";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import { SidebarContext } from "src/contexts/SidebarContext";

function CurrentPlan() {
  const { remainingRequests, isDataLoaded, setShowUpgradeBanner, setShowIncreaseLimitsBanner } = useContext(SidebarContext);

  const totalRequests: number = remainingRequests?.total_credits ?? 100;
  // const userProgress: number = totalRequests - (remainingRequests?.remaining_credits ?? 0);
  const userProgress: number = remainingRequests?.remaining_credits ?? 100;

  const usedRequests: number = totalRequests - userProgress;

  //This is for the circle progress (180 degrees instead of 360 degrees)
  // const scaledValue = (userProgress / 100) * 50;

  const scaledMax = 50; //white part of the circle progress
  const scaledUsed = (usedRequests / totalRequests) * scaledMax; //orange part of the circle progress

  const circleSize = 150;
  console.log("this is remaining Requests", remainingRequests);

  const handleOpenUpgradeBanner = () => {
    setShowUpgradeBanner(true);
  };

  //Conditions for render Upgrade banner
  useEffect(() => {
    const isFreeTierNoRequests = remainingRequests?.subscription_status === "free_tier" && remainingRequests?.remaining_credits === 0;
    const isCanceledWithRequests = remainingRequests?.subscription_status === "canceled" && remainingRequests?.remaining_credits === 0;

    setShowUpgradeBanner(isFreeTierNoRequests || isCanceledWithRequests);
  }, [remainingRequests, setShowUpgradeBanner]);

  //Conditions for render Increase limits banner
  useEffect(() => {
    const hasEnoughRequests = remainingRequests?.remaining_credits === 0;
    const isActiveSubscription = remainingRequests?.subscription_status === "active";

    setShowIncreaseLimitsBanner(hasEnoughRequests && isActiveSubscription);
  }, [remainingRequests, setShowIncreaseLimitsBanner]);

  return (
    <>
      <Grid item xs={12} md={6} sm={8} lg={6} sx={{ fontFamily: "Roboto, arial", display: "flex", flexDirection: "column" }}>
        <Card
          sx={{
            border: `1px solid ${PureLightThemeCaaS.colors.alpha.orange[100]}`,
            backgroundColor: `${PureLightThemeCaaS.colors.alpha.grayBackgroundCard[100]}`,
            boxShadow: "none",
            borderRadius: 0.5,
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {isDataLoaded ? (
            <>
              <CardContent
                sx={{
                  padding: "0px !important",
                }}
              >
                {/* <Box gap={0.5} display="flex" flexDirection="column" justifyContent="space-between" alignItems="center" pb={1.5}> */}
                <Box
                  sx={{
                    borderBottom: `1px solid ${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                    p: 1.5,
                  }}
                >
                  <Typography variant="h4" fontFamily="Roboto, arial" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}>
                    Current plan
                  </Typography>
                </Box>

                <Box display="flex" justifyContent="center" alignItems="center" p={1}>
                  <Typography variant="h4" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`} fontFamily="Roboto, arial">
                    {isDataLoaded
                      ? remainingRequests?.subscription_status === "free_tier"
                        ? "FREE TIER"
                        : remainingRequests?.subscription_status === "canceled"
                          ? "CANCELED ACCOUNT"
                          : "PAID ACCOUNT"
                      : "FREE TIER"}
                  </Typography>
                </Box>
                {/* </Box> */}

                <Box
                  sx={{
                    width: circleSize,
                    height: circleSize / 2,
                    // overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "baseline",
                    position: "relative",
                    margin: "0 auto",
                  }}
                >
                  {/*This values transforms the value of userProgress into a percent (equals the % of circle progress reached) */}
                  <Box
                    sx={{
                      position: "absolute",
                      width: circleSize,
                      height: circleSize,
                      transform: "rotate(-90deg)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {/* Circular progress white */}
                    <CircularProgress
                      variant="determinate"
                      value={scaledMax}
                      size={circleSize}
                      thickness={5}
                      sx={{
                        color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                        "& .MuiCircularProgress-circle": {
                          strokeLinecap: "round",
                        },
                      }}
                    />

                    {/* Circular progress orange */}
                    {isDataLoaded && (
                      <CircularProgress
                        variant="determinate"
                        value={scaledUsed}
                        size={circleSize}
                        thickness={5}
                        sx={{
                          color: `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                          position: "absolute",
                          top: 0,
                          left: 0,
                          "& .MuiCircularProgress-circle": {
                            strokeLinecap: "round",
                          },
                        }}
                      />
                    )}

                    <Typography
                      variant="h4"
                      fontFamily="Roboto, arial"
                      color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}
                      sx={{
                        textAlign: "center",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-30%, -50%) rotate(90deg)",
                      }}
                    >
                      {/* si es request_sub = canceled, que diga 0? que onda el circulo */}
                      Requests {usedRequests < 0 ? 0 : usedRequests}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
              <Divider
                sx={{
                  height: "1px",
                  background: PureLightThemeCaaS.colors.alpha.orange[100],
                  width: "100%",
                  mt: 4,
                  mb: 2,
                }}
              />

              <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" p={1} pl={2} pr={2}>
                <Box pb={0}>
                  <Typography variant="h6" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`} fontFamily="Roboto, arial">
                    {isDataLoaded ? (
                      remainingRequests?.subscription_status === "free_tier" ? (
                        <>
                          RotoGPT provides developers with 100 requests to our API for non-commercial purposes. Need additional non-commercial API requests? Contact us. Visit our
                          pricing page{" "}
                          <a
                            href="https://development.d3eh4f3oqcubae.amplifyapp.com/pricing"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: `${PureLightThemeCaaS.colors.alpha.orange[100]}`, textDecoration: "underline" }}
                          >
                            here
                          </a>{" "}
                          to sign up for a paid account.
                        </>
                      ) : remainingRequests?.subscription_status === "canceled" ? (
                        <>
                          RotoGPT provides developers with 100 requests to our API for non-commercial purposes. Need additional non-commercial API requests? Contact us. Visit our
                          pricing page{" "}
                          <a
                            href="https://development.d3eh4f3oqcubae.amplifyapp.com/pricing"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: `${PureLightThemeCaaS.colors.alpha.orange[100]}`, textDecoration: "underline" }}
                          >
                            here
                          </a>{" "}
                          to sign up for a paid account.
                        </>
                      ) : (
                        <>
                          Paid Account text Lorem ipsum dolor, sit amet consectetur adipisicing elit. Non odio voluptates a exercitationem, voluptatibus, sequi eveniet deleniti
                          illo fugit optio, saepe vero quas similique. Nam eum aliquam error rem aliquid.
                        </>
                      )
                    ) : (
                      <>
                        RotoGPT provides developers with 100 requests to our API for non-commercial purposes. Need additional non-commercial API requests? Contact us. Visit our
                        pricing page{" "}
                        <a
                          href="https://development.d3eh4f3oqcubae.amplifyapp.com/pricing"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: `${PureLightThemeCaaS.colors.alpha.orange[100]}`, textDecoration: "underline" }}
                        >
                          here
                        </a>{" "}
                        to sign up for a paid account.
                      </>
                    )}
                  </Typography>
                </Box>
              </Box>
              {/* {isDataLoaded && remainingRequests?.subscription_status !== "active" ? ( */}
              {/* {remainingRequests?.subscription_status !== "active" ? (
                  <Box display="flex" justifyContent="center">
                    <Box p={1} pb={2}>
                      <Button size="small" variant="contained" color="primary" onClick={handleOpenUpgradeBanner} sx={{ fontFamily: "Roboto, arial" }}>
                        UPGRADE
                      </Button>
                    </Box>
                  </Box>
                ) : null} */}
            </>
          ) : (
            <Box
              sx={{
                position: "relative",
                left: 0,
                top: 0,
                width: "100%",
                height: "100%",
                bgcolor: `${PureLightThemeCaaS.colors.alpha.grayBackgroundCard[100]}`,
              }}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <CircularProgress size={64} disableShrink thickness={3} sx={{ color: `${PureLightThemeCaaS.colors.alpha.orange[100]}` }} />
            </Box>
          )}
        </Card>
      </Grid>
    </>
  );
}

export default CurrentPlan;
